<template>
  <div class="AlternativesTableComponent DataTables">

    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'
import IconSvg from '@/components/shared/IconSvg'

export default {
  name: 'AlternativesTableComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent,
    IconSvg,
  },
  data () {
      return {
        name: 'AlternativesTableComponent',
        mainTable: "",
        id: 'AlternativesTableComponent' + String(this._uid),
        columns: [],
        colsAssign: [],
        alternatives: [],
        isData: false,
        endoflife: null,
        endofsale: null,
        completeInit: false,
        temp: 9,
        firstPriority: 1,
      }
  },
  computed: {
    ...mapGetters({


      globalSettings: "globalSettings",
      currentUser: 'currentUser'
    }),
    partId(){

      if (this.parent == "bom"){
        return this.$store.getters.selectedPartBomRow.partId;
      }
      let partId = "";

      if (this.parent == "partdetails") {
        return this.$route.query.id;
      }
      if (this.$store.getters.selectedRows.length != 0){
        partId = this.$store.getters.selectedRows[0].col___revisionId.partId;


      }
      return partId;


    },
    revisionId() {

      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.revisionId;
      }
      if (this.parent == "partdetails") {
        return this.$route.query.revisionId;
      }
      let revisionId = "";

      if (this.$store.getters.selectedRows.length != 0) {
        revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;


      }
      return revisionId;


    },
    isAssembly() {
      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.assembly;
      }
      if (this.$store.getters.selectedRows.length != 0) {
        return this.$store.getters.selectedRows[0].col___status.assembly;
      }
      return false;
    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    }

  },
  created () {


    this.createTable();


  },
  watch: {
    partId: {
      handler: function(newVal, oldVal){

        this.createTable();
      },
      deep: true


    },


    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {

          if (newValue[el].name == this.name) {

            if (newValue[el].status == true) {

              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },

  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    setSEOverall(data) {

      let _vue = this;

      for (let i = 0, lei = data.length; i < lei; i++){


        let field = document.getElementById(this.parent + "_id_" + data[i].distributorPartId);

        if (field == null) {
          continue;
        }
        if (data[i] == null || data[i].success == false) {

          let str1 = "<button class=\"btn btn-secondary btn-sm btn-" + this.variant + " button_action_overallSE\"><span class=\"risk-text\">SE Risk: </span>";
          let str2 = "<b-badge class='badge badge-primary badge-inbutton'>No data</b-badge> ";
          let str4 = "</button >";
          field.innerHTML = str1 + str2 + str4;
          continue;
        }
        let LifecycleRisk = "";
        let OverallRisk = "";
        if (data[i].seDetails != null) {
          LifecycleRisk = data[i].seDetails.RiskData.LifecycleRisk;
          OverallRisk = data[i].seDetails.LifeCycleData.OverallRisk;

        }
        if (data[i].seDetailsOld != null) {
          LifecycleRisk = data[i].seDetailsOld.LifecycleRisk;
          OverallRisk = data[i].seDetailsOld.OverallRisk;

        }

        let index = OverallRisk.indexOf("%");
        if (index > -1) {
          let temp = OverallRisk.split("%");

          let str1 = "<button class=\"btn btn-secondary btn-sm btn-" + this.variant + " button_action_overallSE\"><span class=\"risk-text\">SE Risk: </span>";
          let str2 = "";
          let str3 = "</button >";
          if (temp[0] <= this.globalSettings.SERiskRange1) {
            str2 = "<b-badge class='badge badge-success badge-inbutton'>Low</b-badge> ";
          }else if (temp[0] > this.globalSettings.SERiskRange2) {
            str2 = "<b-badge class='badge badge-danger badge-inbutton'>High</b-badge> ";
          } else if ((temp[0] > this.globalSettings.SERiskRange1) && (temp[0] <= this.globalSettings.SERiskRange2)) {

            str2 = "<b-badge class='badge badge-warning badge-inbutton'>Medium</b-badge> ";

          }

          if (temp[0] == 0 && LifecycleRisk == "Unknown") {

            str2 = "<b-badge class='badge badge-orange badge-inbutton'>Incomplete</b-badge> "
          }


          field.innerHTML = str1 + str2 +  str3;

          field.children[0].addEventListener("click", function () {

            var obj = {

              text: "",
              type: "SERisk",
              buttons: 1,
              buttonName: "Close",
              size: "xl",
              data: data[i],
              lang: _vue.lang.modal_SERisk,
              funcNo: "",
              funcYes: "",
              funcCustom: ""
            };
            _vue.$store.dispatch("showModalComponent", obj);



          }, false)
        }
      }









    },
    startSEDetails() {
      let distributorPartIds = [];

      for (let i = 0, lei = this.alternatives.length; i < lei; i++){
        // const obj = {
        //   distributorPartId: this.alternatives[i].DistributorPartId,
        //   manufacturerPartNumber: this.alternatives[i].ManufacturerPartNumber,
        //   manufacturerName: this.alternatives[i].ManufacturerName
        // }



        //this.getSEDetails(obj);

        const obj = {
          distributorPartId: this.alternatives[i].DistributorPartId
        }

        distributorPartIds.push(obj);
      }

      this.getSEDetailsByDPI(distributorPartIds);
    },
    getSEDetailsByDPI(distributorPartIds) {

      let vue = this;

      this.$store.dispatch("pm_getSEDetailsByDPI", distributorPartIds)
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            if (result.data.length > 0) {

              vue.setSEOverall(result.data);
            }



          }

        })

    },
    getSEDetails(obj) {
      let vue = this;


      this.$store.dispatch("pm_getSEDetailsByMPN", obj)
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            vue.setSEOverall(obj.distributorPartId, result.data);



          } else {

            vue.setSEOverall(obj.distributorPartId, result.data);
          }

        })
    },
    setNewStatuses(obj) {

      for (let i = 0, lei = this.alternatives.length; i < lei; i++){

            if (this.alternatives[i].DistributorPartId == obj.distributorPartId) {

              this.alternatives[i].isPreferred = obj.isPreferred;
              this.alternatives[i].isNRND = obj.isNRND;
              this.alternatives[i].isForbidden = obj.isForbidden;

            }

          }

      let elem__preferred = document.getElementById("badge__" + this.parent + "_" + obj.distributorPartId + "_preferred");
      let elem__nrnd = document.getElementById("badge__" + this.parent + "_" + obj.distributorPartId + "_nrnd");
      let elem__forbidden = document.getElementById("badge__" + this.parent + "_" + obj.distributorPartId + "_forbidden");
      let cell = document.getElementById("cell__" + this.parent + "_" + obj.distributorPartId);

      if (obj.isPreferred == true) {

        if (elem__preferred == null) {


          if (cell != null) {

            let old = cell.innerHTML;

            let newStatus = "<b-badge id=\"badge__" + this.parent + "_" + obj.distributorPartId+"_preferred\" class='badge badge-success '>" + this.lang.alert_Preferred + "</b-badge> ";
            cell.innerHTML = old + newStatus;
          }
        }
      } else {

        if (elem__preferred != null) {
          elem__preferred.remove();
        }
      }

      if (obj.isNRND == true) {

        if (elem__nrnd == null) {


          if (cell != null) {

            let old = cell.innerHTML;

            let newStatus = "<b-badge id=\"badge__" + this.parent + "_" + obj.distributorPartId+"_nrnd\" class='badge badge-purple '>" + this.lang.alert_NRND + "</b-badge> ";
            cell.innerHTML = old + newStatus;
          }
        }
      } else {

        if (elem__nrnd != null) {
          elem__nrnd.remove();
        }
      }

      if (obj.isForbidden == true) {

        if (elem__forbidden == null) {


          if (cell != null) {

            let old = cell.innerHTML;

            let newStatus = "<b-badge id=\"badge__" + this.parent + "_" + obj.distributorPartId+"_forbidden\" class='badge badge-danger '>" + this.lang.alert_Forbidden + "</b-badge> ";
            cell.innerHTML = old + newStatus;
          }
        }
      } else {

        if (elem__forbidden != null) {
          elem__forbidden.remove();
        }

      }


    },
    createTable() {

      let vue = this;

      const obj = {};
      let action = "";

      if (this.isAssembly == true) {
        action = "_getPhysicalsAssembly";
        obj.partRevisionId = this.revisionId;
      }else {
        action = "_getPhysicals";
        obj.partId = this.partId;
      }


      this.$store.dispatch(this.$store.getters.sectionPrefix + action, obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          vue.alternatives = result.data;
          vue.isData = true;




          let len = vue.alternatives.length;
          if (len > 0) {

            let lastPriority = {
              priority: 1,
              id: 0
            };
            for (let i = 0, lei = len; i < lei; i++){
              vue.alternatives[i].lastPriority = false;

              if (i == 0) {
                this.firstPriority = vue.alternatives[i].Priority;
              }
              if (vue.alternatives[i].Priority > lastPriority.priority) {
                lastPriority.priority = vue.alternatives[i].Priority;
                lastPriority.id = i;
              }

            }

            vue.alternatives[lastPriority.id].lastPriority = true;
          }



          vue.buildColumns();


        }else{
            vue.isData = false;
        }


      })
    },
    format(d) {

    // `d` is the original data object for the row
      let disabled1 = "";
      let disabled2 = "";
      if (d.ByUser == true){
        disabled1 = "disabled";
      }
      if (this.currentUser.role == 'Reader') {
        disabled2 = "disabled";
      }


      let date1 = new Date(d.syncDate);
      let date2 = new Date();

      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));



      let obsolete = "";
      if (diffDays > 7) {
        obsolete = "obsolete";
      }
      let syncDate = '<td>' + this.lang.table_header_Manual + ':</td>' +
        '<td><span >' + this.lang.table_info_Manual + '</span></td>' +
        '</tr>';
      if (d.ByUser == false) {
        syncDate = '<tr>' +
          '<td>' + this.lang.table_header_SyncDate + ':</td>' +
          '<td><span class=\"' + obsolete + '\">' + Tools.longDateToShort(d.syncDate) + '</span></td>' +
          '</tr>';
      }
      let pos = -1;
      let link = d.Datasheet;
      let toDisplay = d.Datasheet;
      if (this.globalSettings.displayHttpLinks == true) {

        pos = toDisplay.indexOf("http");

        if (pos > -1) {
          toDisplay = "<a href='" + link + "' target='_blank'>Link</a>";
        }
      }
      if (this.globalSettings.displayLocalLinks == true) {
        pos = toDisplay.indexOf("\\\\");
        if (pos > -1) {

          link = toDisplay.split('\\').join('/');

          link = "file:///" + link
          toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
        }
        pos = link.indexOf("file://");
        if (pos > -1) {

          toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
        }
      }
      let a = d.ManufacturerPartNumber + "__" + d.ManufacturerName + "__" + d.isSE;


      let checkedPreferred = "";
      if (d.isPreferred == true) {
        checkedPreferred = "checked";
      }
      let checkedNRND = "";
      if (d.isNRND == true) {
        checkedNRND = "checked";
      }
      let checkedForbidden = "";
      if (d.isForbidden == true) {
        checkedForbidden = "checked";
      }
      let disabled = "";
      if (this.currentUser.role == "Reader") {
        disabled = "disabled";
      }


      let accepted = false
      let aaa = true

      return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%;">'+
                '<tr>'+
                    '<td>'+this.lang.table_header_Description+':</td>'+
                    '<td>'+d.Description+'</td>'+
                '</tr>' +
                '<tr>' +
                    '<td>' + this.lang.table_header_Datasheet + ':</td>' +
                    '<td>' + toDisplay + '</td>' +
                '</tr>' +
                '<tr>'+
                    '<td>'+this.lang.table_header_Login+':</td>'+
                    '<td>'+d.LoginAssign+'</td>'+
                '</tr>'+
                '<tr>'+
                    '<td>'+this.lang.table_header_Date+':</td>'+
                    '<td>'+Tools.longDateToShort(d.DateAssign)+'</td>'+
                '</tr>'+
                syncDate +
                '<tr>'+
                    '<td>Tags:</td>'+
                    '<td>' +
                      '<div class=\"custom-control-inline custom-checkbox input-tags\"><input '+ disabled + ' ' + checkedPreferred + '  type=\"checkbox\" class=\"custom-control-inline checkbox_type custom-control-primary custom-control-sm\" id=\"checkbox_preferred_' + d.DistributorPartId + '\" value=\"' + accepted + '\">Preferred</div>' +

                      '<div class=\"custom-control-inline custom-checkbox input-tags\"><input '+ disabled + ' ' + checkedNRND + '  type=\"checkbox\" class=\"custom-control-inline checkbox_type custom-control-primary custom-control-sm\" id=\"checkbox_nrnd_' + d.DistributorPartId + '\" value=\"' + accepted + '\">NRND</div>' +

                      '<div class=\"custom-control-inline inline custom-checkbox input-tags\"><input '+ disabled + ' ' + checkedForbidden + '  type=\"checkbox\" class=\"custom-control-inline checkbox_type custom-control-primary custom-control-sm\" id=\"checkbox_forbidden_' + d.DistributorPartId + '\" value=\"' + accepted + '\">Forbidden</div>' +
                    '</td>' +
                '</tr>' +
                '<tr>'+
                    '<td>Action:</td>'+
                    '<td><button  ' + disabled2 + ' class=\"btn btn-sm btn-'+this.variant+' button-action-unassign\" id=\"button_unassign__'+ d.DistributorPartId + '">'+this.lang.table_button_Unassign+'</button><button  class=\"btn btn-sm  btn-'+this.variant+' button-action-unassign\" id=\"button_details__'+ d.DistributorPartId + '" data-obj=\"'+a+'\">'+this.lang.table_button_Details+'</button><button  ' + disabled1 + ' '+ disabled2 +' class=\"btn btn-sm  btn-'+this.variant+' button-action-sync\" id=\"button_sync__'+ d.DistributorPartId + '"><span class="spinner-border spinner-border-sm spiner-sync"></span> <span class="button-text">'+this.lang.table_button_Sync+'</span></button></td>'+
                '</tr>'+
            '</table>';
    },
    buildColumns(){

      this.columns = [
        {
          name: this.lang.table_header_Expand,
          alignInColumn: "left",
          type: "text",
          width: 50
        },
        {
          name: this.lang.table_header_Priority,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Priority,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Image,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: this.lang.table_header_SEStatus,
        //   alignInColumn: "left",
        //   type: "text"
        // },
        {
          name: this.lang.table_header_ManufacturerName,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_ManufacturerPartNumber,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Datasheet,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Login,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Date,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_SyncDate,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Action,
          alignInColumn: "left",
          type: "text"
        },


      ]

      this.colsAssign =  [

        {
            "className": 'details-control',
            "orderable": false,
            "data": null,
            "defaultContent": '<img src="/static/plus.svg">'
        },
        { "data": "Priority" },
        { "data": "Priority" },
        { "data": "imageUrl" },
        { "data": "DistributorPartId" },
        //{ "data": "DistributorPartId" },
        { "data": "ManufacturerName" },
        { "data": "ManufacturerPartNumber" },
        { "data": "Description" },
        { "data": "Datasheet" },
        { "data": "LoginAssign"},
        { "data": "DateAssign"},
        { "data": "syncDate"},
        { "data": "DistributorPartId" },

      ]

      this.buildTable();
    },
    buildTable(){
      this.completeInit = false;

      var tableplace = document.getElementById(this.id);

          if (tableplace == null){
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "headerCell");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function (data, type, row, meta) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                if (meta.col == 2) {
                  let arrow_disabled1 = "";
                  let arrow_disabled2 = "";

                  if (row.Priority == _vue.firstPriority) {
                    arrow_disabled2 = "disabled=\"disabled\"";
                  } else if (row.lastPriority == true) {
                    arrow_disabled1 = "disabled=\"disabled\"";
                  }

                  if (row.Priority == _vue.firstPriority && row.lastPriority == true) {
                    arrow_disabled2 = "disabled=\"disabled\"";
                    arrow_disabled1 = "disabled=\"disabled\"";
                  }

                  if (_vue.currentUser.role == 'Reader') {
                    arrow_disabled2 = "disabled=\"disabled\"";
                    arrow_disabled1 = "disabled=\"disabled\"";
                  }

                  let str = "<button " + arrow_disabled1 + " id=\"down__" + row.DistributorPartId + "\" class=\"btn btn-arrow btn-" + _vue.variant + "\">&ShortDownArrow;</button>";
                  str += "<button " + arrow_disabled2 + " id =\"up__" + row.DistributorPartId + "\" class=\"btn btn-arrow btn-" + _vue.variant + "\">&ShortUpArrow;</button>"

                  return str;
                }
                if (meta.col == 3){
                  if ((data != null) && (data != "") && ((data.indexOf("http://") != -1) || (data.indexOf("https://") != -1))){

                    return "<img class=\"image\" height='40px' src='"+data+"'>";
                  }
                  return "<img class=\"imageSVG\" height='40px' src='/static/part.png'>";
                }
                if (meta.col == 4) {
                  let str = "";
                  let tags = false;
                  str += "<span id=\"cell__" + _vue.parent + "_" + row.DistributorPartId + "\">";

                  if(row.endOfPartAlert){
                    str += "<b-badge id=\"badge__" + _vue.parent + "_" + row.DistributorPartId + "_endofpart\" class='badge badge-danger '>" + _vue.lang.alert_EndOfPart + "</b-badge> ";
                    tags = true;
                  }
                  if(row.isPreferred){
                    str += "<b-badge id=\"badge__" + _vue.parent + "_" + row.DistributorPartId + "_preferred\" class='badge badge-success '>" + _vue.lang.alert_Preferred + "</b-badge> ";
                    tags = true;
                  }
                  if(row.isNRND){
                    str += "<b-badge id=\"badge__" + _vue.parent + "_" + row.DistributorPartId + "_nrnd\" class='badge badge-purple '>" + _vue.lang.alert_NRND + "</b-badge> ";
                    tags = true;
                  }
                  if(row.isForbidden){
                    str += "<b-badge id=\"badge__" + _vue.parent + "_" + row.DistributorPartId + "_forbidden\" class='badge badge-danger '>" + _vue.lang.alert_Forbidden + "</b-badge> ";
                    tags = true;
                  }
                  str += "</span>";
                  let id = _vue.parent + "_id_" + row.DistributorPartId;

                  let overall = "";


                  let hr = "";
                  if (_vue.globalSettings.SEDetails == true) {
                    let SEoutofdate = "";
                    // if (row.SEoutofdate != undefined) {
                    //   if (row.SEoutofdate == true) {
                    //     SEoutofdate = "!"
                    //   }
                    // }

                    overall = "<span id=" + id + "><button data-seoutodate=\"" + SEoutofdate + "\" class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button_action_overallSE\"><span class=\"risk-text\">SE Risk: </span><b-badge class='badge badge-primary ' ><span class=\"spinner-border spinner-border-sm text-" + _vue.variant + "\" ></span></b-badge></button></span>";


                    if (str != "" && tags == true) {
                      hr = "<hr class=\"risk-hr\">";
                    }
                  }


                  return str + hr + overall;
                }


                if (meta.col == 10){
                    return Tools.longDateToShort(data);
                }

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);

            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

      }

      var _vue = this;


          var option = {};
          option.paging = false;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.alternatives;
          option.myColumnFormats = this.columns;
          option.select = false;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {

            if (_vue.completeInit == false) {
              _vue.completeInit = true;

              if (_vue.globalSettings.SEDetails == true) {
                _vue.startSEDetails();
              }


            }



          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();

          }



          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 1 ).visible( false );
          // if (_vue.globalSettings.SEDetails == false) {
          //   this.mainTable.column( 5 ).visible( false );
          // }
          // this.mainTable.column( 6 ).visible( false );
          this.mainTable.column( 7 ).visible( false );
          this.mainTable.column( 8 ).visible( false );
          this.mainTable.column( 9 ).visible( false );
          this.mainTable.column(10).visible(false);
          this.mainTable.column(11).visible(false);
          this.mainTable.column(12).visible(false);




          let _mainTable = this.mainTable;

          this.mainTable
            .on( 'select', function ( e, dt, type, indexes ) {

              var rowData = _mainTable.rows( indexes ).data();


              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", rowData[0])

            })
            .on( 'deselect', function ( e, dt, type, indexes ) {

              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
            })

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          $('#t_'+this.id +' tbody').on('click', 'td.details-control', function (e) {


            var tr = $(this).closest('tr');
            var row = _mainTable.row( tr );

            if ( row.child.isShown() ) {
                // This row is already open - close it
                e.target.src = "/static/plus.svg";
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                e.target.src = "/static/minus.svg";
                row.child( _vue.format(row.data()) ).show();
                tr.addClass('shown');
            }
          } );

          $("#t_"+this.id + ' tbody').on( 'click', 'button', function (e) {



            let temp = this.id.split("__")



            if (temp[0] == "button_unassign"){

                let alert_success_unassignAlternative = _vue.lang.alert_success_unassignAlternative;
                let alert_error_unassignAlternative = _vue.lang.alert_error_unassignAlternative;

                let partId = "";
                if (_vue.$route.path == "/ProjectManager/ProjectBom"){
                  partId = _vue.$store.getters.selectedPartBomRow.partId;
                } else {

                  if (_vue.$store.getters.selectedRows.length != 0) {
                    partId = _vue.$store.getters.selectedRows[0].col___revisionId.partId;
                  }

                  if (_vue.$route.path == "/PartManager/PartDetails") {
                    partId = _vue.$route.query.id;
                  }
                }

                let unassignParts = function(_vue){
                    let obj = {
                        partId: partId,
                        alternatives: [{
                            distributorPartId: temp[1]
                        }]
                    }

                    _vue.$store.dispatch("unassignPhysicals", obj)
                    .then((result) => {

                        console.log(result)
                        if (result.status == "OK"){
                        //alert
                            if (result.data == 1){

                                _vue.$store.dispatch("unselectAlternative");
                                let reloadObj = {
                                    status: true,
                                    name: "AlternativesTableComponent"
                                }
                                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                                reloadObj = {
                                    status: true,
                                    name: "HistoryDetailsComponentdetails"
                                }
                                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                                reloadObj = {
                                    status: true,
                                    name: "HistoryDetailsComponenttasks"
                                }
                                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);


                                let objPart = {
                                  distributorPartId: temp[1],
                                  type: "unassignPhysicals"
                                }

                                _vue.$store.commit("RELOADPARTINBOM", objPart)

                                const obj = {
                                  text: alert_success_unassignAlternative,
                                  time: 5,
                                  type: "success"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }else{
                                const obj = {
                                  text: alert_error_unassignAlternative,
                                  time: 15,
                                  type: "danger"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }


                        }
                    })


                }

                const obj = {
                    title: _vue.lang.alert_Title,
                    text: _vue.lang.alert_Text,
                    type: "withdraw",
                    buttons: 2,
                    size: "sm",
                    funcYes: unassignParts,
                    funcNo: "",

                }

                _vue.$store.dispatch("showAlert", obj);


            }
            if (temp[0] == "button_details") {

              let mn = $(this).attr("data-obj");

              let temp2 = mn.split("__");

                let obj = {
                  distributorPartId: temp[1],
                  manufacturerPartNumber: temp2[0],
                  manufacturerName: temp2[1],
                  isSE: (temp2[2] === "true")
                }

                _vue.$store.dispatch("selectAlternative", obj)


            }
            if (temp[0] == "button_sync"){

              //let button_text =  document.getElementsByClassName("button-text");
              let button_action_sync = document.getElementsByClassName("button-action-sync");


              let spinner_button = document.getElementsByClassName("spiner-sync");
              let spinner = null;
              if (spinner_button != null) {
                for (let i = 0, lei = button_action_sync.length; i < lei; i++){

                  let sp = button_action_sync[i].id.split("__");

                  if (sp[1] == temp[1]) {
                    button_action_sync[i].style.width = "60px";
                    button_action_sync[i].children[0].style.display = "block";
                    button_action_sync[i].children[0].style.float = "left";
                    spinner = button_action_sync[i];
                //button_text[0].style.display = "none";
                  }
                }

              }

              let alert_success_syncAlternative = _vue.lang.alert_success_syncAlternative;
              let alert_error_syncAlternative = _vue.lang.alert_error_syncAlternative;

              let obj = {
                  distributorPartId: temp[1]
              }

              _vue.$store.dispatch("pm_syncDistributorPart", obj)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){

                  if (result.data == 1){


                      const reloadObj = {
                          status: true,
                          name: "AlternativesTableComponent"
                      }
                      _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);


                      const obj = {
                      text: alert_success_syncAlternative,
                      time: 5,
                      type: "success"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);
                  }else{
                      const obj = {
                      text: alert_error_syncAlternative + ".",
                      time: 15,
                      type: "danger"
                      }

                    _vue.$store.dispatch("displayFooterAlert", obj);

                    spinner.style.width = "33px";
                    spinner.children[0].style.display = "none";
                    spinner.children[0].style.float = "left";
                  }


                }else{
                  const obj = {
                    text: alert_error_syncAlternative + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                  spinner.style.width = "33px";
                  spinner.children[0].style.display = "none";
                  spinner.children[0].style.float = "left";
                }
              })


            }
            // if (this.checked == true){
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addAlternativePart", obj)

            // }else{
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteAlternativePart", obj)

            // }




          })

          let buttons_action_arrow = document.getElementsByClassName('btn-arrow');


          for (var i = 0; i < buttons_action_arrow.length; i++) {
            buttons_action_arrow[i].addEventListener('click', function (vue) {


              let tab = this.id.split("__");
              let dir = tab[0];
              let distributorPartId = tab[1];



              const obj = {
                dir: dir,
                distributorPartId: distributorPartId,
                partId: _vue.partId
              }


              _vue.$store.dispatch("pm" + "_changeMPNPriority", obj)
                .then((result) => {

                  console.log(result)


                  if (result.data != null) {


                    const obj = {
                      text: _vue.lang.alert_success_ChangeMPNPriority,
                      time: 10,
                      type: "success"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);


                    const reloadObj = {
                      status: true,
                      name: "AlternativesTableComponent"
                    }

                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  } else {


                    const obj = {
                      text: _vue.lang.alert_error_ChangeMPNPriority + " Error: " + result.message,
                      time: 15,
                      type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);

                  }


              })
            })

          }

          $("#t_"+this.id + ' tbody').on( 'input', '.input-tags', function (e) {

            let temp = e.target.id.split("_")


            let distributorPartId = temp[2];

            let tagCheckboxes = document.getElementsByClassName('input-tags');


            const obj = {
              distributorPartId: distributorPartId,
              isPreferred: null,
              isNRND: null,
              isForbidden: null
            }
            for (let i = 0, lei = tagCheckboxes.length; i < lei; i++){


              let temp2 = tagCheckboxes[i].firstChild.id.split("_")


              if (distributorPartId == temp2[2]) {
                if (temp2[1] == "preferred") {
                  obj.isPreferred = tagCheckboxes[i].firstChild.checked;
                }
                if (temp2[1] == "nrnd") {
                  obj.isNRND = tagCheckboxes[i].firstChild.checked;
                }
                if (temp2[1] == "forbidden") {
                  obj.isForbidden = tagCheckboxes[i].firstChild.checked;
                }

              }
            }



            const objStatus = obj;

            //_vue.setNewStatuses(objStatus);

            _vue.$store.dispatch("pm" + "_setStatusMPN", obj)
              .then((result) => {

                console.log(result)


                if (result.data != null) {


                  const obj = {
                    text: _vue.lang.alert_success_StatusMPN,
                    time: 10,
                    type: "success"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);


                  _vue.setNewStatuses(objStatus);



                  objStatus.type = "setStatusMPN";

                  _vue.$store.commit("RELOADPARTINBOM", objStatus)

                } else {


                  const obj = {
                    text: _vue.lang.alert_error_StatusMPN + " Error: " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);

                }


            })

          })


        },


  }
}
</script>


<style lang="scss">


  @import "./../../scss/_custom.scss";

  .AlternativesTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 2px;
    }
    td.details-control {
      //background: url("/static/plus.svg") no-repeat center center;
      img{
        max-width: 30px;
        padding: 2px;
      }

    }
    tr.shown td.details-control {
      img{
        max-width: 30px;
        padding: 2px;
      }
      //background: url("/static/minus.svg") no-repeat center center;
    }
    .button-action-unassign{
        margin: 2px;
    }
    .button-action-sync{
        margin: 2px;
    }
    .spiner-sync{
      display: none;
    }
    .obsolete{
      color: $orange;
    }
    .badge{
      margin: 2px;
    }
    .button_action_overallSE{
      margin-top: 5px;
      margin-bottom: 3px;
      white-space: nowrap;
      width: 100%;
      text-align: left;

    }
    .badge-inbutton{
      //float:right;
    }
    .risk-text{
      //float:left;
    }
    .risk-hr{
      margin-top: 3px;
      margin-bottom: 1px;
    }
    .btn-arrow{
      padding: 2px;
      margin: 2px;
    }
    .red{
      color: $orange;

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AlternativesTableComponent.vue